import React, { PureComponent } from 'react';// eslint-disable-line
import PropTypes from "prop-types";
import OutsideClickHandler from 'react-outside-click-handler';
import generate from 'shortid';

import { WHITE, GREY } from '../../../styles/shared/colors';
import arrow from '../../../assets/imgs/dropdown-arrow.svg';
import './Dropdown.scss';

class Dropdown extends PureComponent {
  static propTypes = {
    color: PropTypes.string,
    displayedProperty: PropTypes.string,
    hasSelectAllOption: PropTypes.bool,
    isControlled: PropTypes.bool,
    items: PropTypes.array,
    onOutsideClick: PropTypes.func,
    onSelect: PropTypes.func,
    parentShouldRenderList: PropTypes.bool, // eslint-disable-line 
    placeholder: PropTypes.string,
    placeholderColor: PropTypes.string,
    selectAllText: PropTypes.string,
    selectedItem: PropTypes.object || PropTypes.string
  };

  static defaultProps = {
    color: WHITE,
    displayedProperty: "",
    hasSelectAllOption: false,
    isControlled: false,
    items: [],
    onOutsideClick: null,
    onSelect: () => { },
    parentShouldRenderList: false,
    placeholder: "",
    placeholderColor: GREY,
    selectAllText: "Select All",
    selectedItem: null
  };

  state = {// eslint-disable-line
    selectedItem: "",
    shouldRenderList: false
  };

  componentDidMount() {
    const { selectedItem } = this.props;
    if (selectedItem) {
      this.setState({
        selectedItem
      });
    };
  };

  componentDidUpdate(prevProps) {
    const { parentShouldRenderList, isControlled, selectedItem } = this.props;
    if (isControlled && parentShouldRenderList !== prevProps.parentShouldRenderList) {
      this.setState({// eslint-disable-line
        shouldRenderList: parentShouldRenderList
      })
    }

    if (prevProps.selectedItem !== selectedItem) {
      this.setState({// eslint-disable-line
        selectedItem
      });
    }
  }

  toggleShouldRenderList = () => {
    this.setState(prevState => ({
      shouldRenderList: !prevState.shouldRenderList
    }));
  };

  handleSelectItem = item => {
    const { onSelect } = this.props;

    if (onSelect) {
      onSelect(item);
    };
    this.setState({
      selectedItem: item,
      shouldRenderList: false
    });
  };

  handleClickOutside = () => {
    const { onOutsideClick } = this.props;
    if (onOutsideClick) {
      onOutsideClick();
      return;
    }

    this.setState({
      shouldRenderList: false
    })
  }

  render() {
    const { items, placeholder, displayedProperty, isControlled, selectAllText, hasSelectAllOption, color, placeholderColor } = this.props;
    const { selectedItem, shouldRenderList } = this.state;

    return (
      <div className="dropdown">
        <OutsideClickHandler
          onOutsideClick={this.handleClickOutside}
        >
          {!isControlled &&
            <button className="dropdown__button" type="button" onClick={this.toggleShouldRenderList}>
              <div className="dropdown__button__text">
                <span style={{ color: selectedItem ? color : placeholderColor }}>
                  {selectedItem ?// eslint-disable-line
                    typeof selectedItem === 'string' ?
                      selectedItem :
                      selectedItem[displayedProperty] : placeholder}
                </span>
                <img className="dropdown__button__text__arrow" src={arrow} alt="" />
              </div>
            </button>}
          <div className="dropdown__list" style={{ maxHeight: shouldRenderList ? "200px" : "0px" }}>
            {hasSelectAllOption &&
              <button key={selectAllText} className="dropdown__list__item" type="button" onClick={() => this.handleSelectItem("")}>
                <span>{selectAllText}</span>
              </button>}
            {items.map(item =>
              <button key={generate()} className="dropdown__list__item" type="button" onClick={() => this.handleSelectItem(item)}>
                <span>
                  {typeof item === "string" ?
                    item :
                    item[displayedProperty]}
                </span>
              </button>
            )}
          </div>
        </OutsideClickHandler>
      </div>
    );
  }
};

export default Dropdown;